import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var WidgetConfig = require('lib/widgets/WidgetsConfig')

@connect(
  (state, props) => ({
  }),

  (dispatch, props) => ({
    populateData: () => {
      // load book data
    }
  })
)

@providePopulateData()
class BookWidget extends React.Component {
  constructor(props) {
    super();
    autobind(this);
    LuckyOrangeClient.tagComponent("BookWidget");
  }

  isStudentDash() {
    return this.props.user.role == WidgetConfig.STUDENT_ROLE
  }

  // handles expansion of component
  onClick(item) {
    console.log(item)
    // show appropriate component based on widget item
  }

  buildWidgetItemLink(digest, itemConfig, item) {
    var { link } = itemConfig
    var { user } = this.props
    // build link object for widget item

    // REPLACE THIS SECTION WHEN //
    // WE CAN EXPAND COMPONENTS //
    if (this.isStudentDash()) {
      return {
        text: link.text,
        location: WidgetConfig.buildStudentDataLink(user.id, link.filters, link.subject, digest)
      }
    }
    /////////////////////////////
    else if (link.expand_component) {
      return {
        text: link.text,
        expand_component: true,
        location: this.onClick.bind(this, item)
      }
    } else {
      return link
    }
  }

  renderWidgetItems() {
    return WidgetConfig.renderWidgetItems(this.props, WidgetConfig.BOOK_WIDGET, this.buildWidgetItemLink, this.props.showEmptyState)
  }

  renderWidgetTitle() {
    return WidgetConfig.renderWidgetTitle(WidgetConfig.BOOK_WIDGET)
  }

  render() {
    return (
      <div className="widgetItemsContainer bookWidget">
        {this.renderWidgetTitle()}
        {this.renderWidgetItems()}
      </div>
    )
  }
};

BookWidget.WrappedComponent.propTypes = PageStrictPropTypes({
  // @connect handlers
  populateData: PropTypes.func,
  selectStudentList: PropTypes.func,
  selectWidgetDigests: PropTypes.func,

  user: PropTypes.object,
  periodWidgetDigests: PropTypes.array,
  currentWidgetDigests: PropTypes.array,
  compWidgetDigests: PropTypes.array,
  yearlyWidgetDigests: PropTypes.array,
  compSize: PropTypes.number,
  compScope: PropTypes.string,
  showEmptyState: PropTypes.bool,
});

module.exports = BookWidget;


// WEBPACK FOOTER //
// ./modules/components/data/widgets/BookWidget.js